export enum READ_ACTION_TYPES {
	RESET_PERISCOPE = 'reset_periscope',
	RESET_ANALYSIS_PERISCOPE = 'reset_analysis_periscope'
}
